import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import $ from '../../../../common/AjaxRequest';
import API_URL from '../../../../common/url';
import ExportUtil from '../../../../common/ExportUtil';
import TableC from '../../../basicElement/TableC';


class MainScoreDetail extends Component {

    state = {
        visible: false,
        data:[],
        record:{},
        loading:false,
        pagination: {
            current: 1,
            limit: 10,
        },
    }

    show = record => {
        this.setState({ visible: true, record }, this.loadData)
    }

    loadData = () =>{
        const { pagination:{ current, limit }, record:{ userId, year, month }, pagination } = this.state;
        this.setState({ loading:true })
        const options = {
            method: 'POST',
            url: API_URL.user.queryPositionCrcDetailList,
            data: {
                limit,
                userId,
                offset: current,
                isRecord:2,
                recordYear:year,
                recordMonth:month,
            },
            dataType: 'json',
            doneResult: res => {
                pagination.total = res.totalCount;
                this.setState({
                    loading: false,
                    data: res.datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    getColumns = () => {
        const columns = [{
            title: '时间',
            dataIndex: 'yearMonth',
            key: 'yearMonth',
            width: 80,
            render: ( text, record) => {
                const { year, month } = record;
                return `${year}-${month}`
            }
        },{
            title: '总分',
            dataIndex: 'trueTotalPoint',
            key: 'trueTotalPoint',
            width: 80,
        },{
            title: '主要业绩分',
            dataIndex: 'mainAchievementPoint',
            key: 'mainAchievementPoint',
            width: 80,
        },{
            title: '加分',
            dataIndex: 'bonusPoint',
            key: 'bonusPoint',
            width: 80,
        },{
            title: '减分',
            dataIndex: 'minusPoint',
            key: 'minusPoint',
            width: 80,
        },]
        return columns
    }
    
    handleCancel = () => {
        this.setState({
            visible: false,
            data:[],
            record:{},
            loading:false,
            pagination: {
                current: 1,
                limit: 10,
            },
        })
    }

    export = () => {
        const { record:{ userId, year, month } } = this.state;
        ExportUtil.export({ userId, recordYear:year, recordMonth:month, isAdd:2  }, null, API_URL.user.exportCrcPostRecord);
    }

    handleTableChange = params => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    render () {
        const { visible, data, pagination, record, loading } = this.state;
        return(
            <Modal
                title="主要技能分明细"
                visible={visible}
                width={700}
                onCancel={this.handleCancel}
                footer={<Button onClick={this.handleCancel}>关闭</Button>}
                >
                    <div style={{ padding:'0 20px 20px 20px' }}>
                    <span>{`时间：${record.recordYearMonth}`}</span>
                        <Button style={{ float:'right' }} type="primary" onClick={this.export}>导出</Button>
                    </div>
                    <TableC
                        data={data}
                        loading={loading}
                        pagination={pagination}
                        columns={this.getColumns()}
                        onChange={this.handleTableChange}
                    />
            </Modal>
        )
    }
}

export default MainScoreDetail


// WEBPACK FOOTER //
// ./src/components/user/crcPostRank/components/MainScoreDetail.js